import { Box } from '@chakra-ui/layout';
import type { MouseEventHandler } from 'react';

import { Loading } from '@revelio/core';

import { useSafeChart } from './ChartProvider';

export const ChartLoader = ({
  onClick,
}: {
  onClick?: MouseEventHandler<HTMLDivElement>;
}) => {
  const { variant, onEditClick } = useSafeChart();
  const handleClick = onClick ?? onEditClick;
  const capLoaderToViewport = variant === 'report';

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      position="absolute"
      top="0"
      left="0"
      width="100%"
      height="100%"
      {...(capLoaderToViewport ? { maxH: '100vh' } : {})}
      zIndex="2"
      backgroundColor="var(--ui-chakra-bg-primary, #ffffff)"
      borderRadius="var(--chakra-radii-md)"
      onClick={handleClick}
    >
      <Loading size="sm" />
    </Box>
  );
};
